<template>
  <div v-resize="onResize">
    <v-card elevation="0" class="mx-3">
      <div class="bids-wrap outer">
        <div class="bids-wrap inner">
          <div
            id="bidsWrap"
            :style="{height:bidsWrapHeight}"
            class="bids-container d-flex overflow-y-auto"
            :class="{ 'overflow-x-auto': bids.length }"
          >
            <div class="bids">
              <div v-for="bidStage in bidStages" class="pa-1">
                <span
                  class="bidTitle pa-2 d-block"
                  :style="{
                    background: bidStage.color,
                    color: getCorrectTextColor(bidStage.color),
                  }"
                >
                  {{
                    parseInt(bidStage.is_system) === 1
                      ? $t(`viewBids.stages.${bidStage.system_name}`)
                      : bidStage.name
                  }}
                </span>
                <draggable
                  handle=".handle"
                  ghost-class="ghost"
                  class="list-group dropZone"
                  :list="bids.filter((bid) => bid.bid_stage_id === bidStage.id)"
                  group="people"
                  @end="changeBid"
                  :data-stage-id="bidStage.id"
                >
                  <div
                    v-for="bid in bids.filter(
                      (bid) => bid.bid_stage_id === bidStage.id
                    )"
                    class="oneBid"
                    :data-bid-id="bid.id"
                    :key="bid.id"
                  >
                    <div class="d-flex">
                      {{ bid.created_at | moment("DD.MM.YYYY HH:mm") }}
                      <v-icon small class="ml-auto handle ma-0 pa-0"
                        >fa-arrows-alt</v-icon
                      >
                    </div>
                    <v-divider></v-divider>
                    <div>
                      <span v-if="bid.customer">
                        <span
                          class="dashed"
                          @click="
                            customerId = bid.customer.id;
                            customerEditForm = true;
                          "
                        >
                          {{ bid.customer.full_name }}
                        </span>
                      </span>
                      <span v-else>
                        {{ bid.customer_name }}
                      </span>
                      <div class="d-block"></div>
                      <v-btn
                        v-if="bid.order"
                        small
                        elevation="0"
                        class="mb-0 light-blue--text"
                        @click="
                          commentWindow.isVisible = true;
                          commentWindow.orderId = bid.order.id;
                        "
                        @keyup.enter="
                          commentWindow.isVisible = true;
                          commentWindow.orderId = bid.order.id;
                        "
                      >
                        <v-icon small>fa-comment</v-icon>
                      </v-btn>
                      <span
                        v-if="bid.order"
                        @click="handleClickOrderForBid(bid)"
                        class="dashed"
                      >
                        {{ $t("common.order") }} #{{ bid.order.human_number }}
                      </span>
                      <span class="d-block success--text" v-if="bid.order">
                        {{ formatCurrency(parseFloat(bid.order.total_sum).toFixed(2)) }}
                      </span>
                      <span v-if="bid.car">
                        <span>
                          {{ bid.car.name }}
                        </span>
                        <beauty-car-number
                          v-if="bid.car && bid.car.car_number"
                          :number="bid.car.car_number"
                        ></beauty-car-number>
                      </span>
                      <span v-else>
                        {{ bid.brand }} {{ bid.model }}
                        <beauty-car-number
                          v-if="bid.car_number"
                          :number="bid.car_number"
                        ></beauty-car-number>
                      </span>
                      <span v-if="!bid.order" class="d-block">
                        <v-btn
                          small
                          elevation="0"
                          class="mb-0 ml-0 white--text"
                          color="blue"
                          :title="$t('common.creating_order')"
                          :disabled="cartIsLoading"
                          @click="handleClickOrderForBid(bid)"
                        >
                          <v-icon x-small class="mr-1">$cart</v-icon>
                          {{ $t("common.create_order") }}
                        </v-btn>
                      </span>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="bids.length == 0" class="pa-3">
        {{ $t("common.no_data_available") }}
      </div>
    </v-card>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @update="
          (data) => {
            this.customerEditForm = false;
            this.getForPeriod();
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <order-messages-window
      :order-id="commentWindow.orderId"
      :show="commentWindow.isVisible"
      @hide="commentWindow.isVisible = false"
    ></order-messages-window>
    <order-window
        :is-visible="orderWindow.isVisible"
        :order-id="orderWindow.orderId"
        @hide="orderWindow.orderId=null; orderWindow.isVisible=false;getForPeriod()"
    />
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import draggable from "vuedraggable";
import CustomerForm from "@/components/customer/CustomerForm.vue";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";
import CommonMixin from "@/mixins/common";
import BidsMixin from "@/mixins/bids";
import OrderMessagesWindow from "@/components/order/OrderMessagesWindow";
import OrderWindow from "@/components/order/OrderWindow.vue";

export default {
  data: () => ({
    commentWindow: {
      isVisible: false,
      orderId: null,
    },
    maintenancePartsForm: "",
    bidTab: 0,
    bidsWrapHeight: '200px',
    customerEditForm: false,
    customerId: null,
    ready: false,
    orderWindow: {
      orderId: null,
      isVisible: false
    }
  }),
  components: {
    OrderWindow,
    OrderMessagesWindow,
    draggable,
    BeautyCarNumber,
    CustomerForm,
  },
  mixins: [CommonMixin, BidsMixin],
  mounted() {
    this.$store.dispatch("bid_stages/get");
    let from = new Date();
    from.setMonth(from.getMonth() - 1);
    this.period.from = from.toISOString().slice(0, 10);
    this.period.to = new Date().toISOString().slice(0, 10);
    this.$nextTick(() => {
      this.ready = true;
      this.getForPeriod();
    });
  },
  watch: {
    "period.from"() {
      if (!this.ready) return;
      this.getForPeriod();
    },
    "period.to"() {
      if (!this.ready) return;
      this.getForPeriod();
    },
  },
  computed: {
    ...mapFields("bid_stages", ["bidStages"]),
    ...mapFields("cart", ["cartIsLoading", "carts"]),
    ...mapFields("bids", [
      "period",
      "bids",
      "tableOptions",
      "search",
      "itemsTotalCount",
      "fetched",
    ]),
  },
  methods: {
    onResize(){
      this.$nextTick(() => {
        if (!document.getElementById("bidsWrap")) {
          this.bidsWrapHeight = "";
          return;
        }
        //document.getElementById("bidsWrap").style.height = "auto";
        let element = document.getElementById("bidsWrap");
        let top = 0;
        do {
          top += element.offsetTop || 0;
          element = element.offsetParent;
        } while (element);
        this.bidsWrapHeight = window.innerHeight - top - 30 + "px";
      });
    },
    changeBid(evt) {
      if (evt.from.dataset.stageId !== evt.to.dataset.stageId) {
        this.bids.forEach((bid) => {
          if (parseInt(bid.id) === parseInt(evt.item.dataset.bidId)) {
            bid.bid_stage_id = parseInt(evt.to.dataset.stageId);
            this.$store.dispatch("bids/update", bid).then((res) => {
              if (!res) this.getForPeriod();
            });
          }
        });
      }
    },
    getForPeriod() {
      this.$store.dispatch("bids/getForPeriod", this.period);
    },
  },
};
</script>
<style>
.handle {
  display: inline-block;
  height: 16px;
  width: 16px;
  cursor: move;
}
.bids-wrap {
  display: flex;
}
.bids-wrap.inner {
  overflow: hidden;
}

.bids-container {
  /*overflow-x: auto;*/
  display: flex;
}
.bids {
  display: flex;
}
.bids > div {
  min-width: 200px;
  /*flex-shrink: 0;*/
  flex-grow: 1;
  flex-basis: 0;
}
.bidTitle {
  border-radius: 10px;
}
.oneBid {
  padding: 5px;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  margin-top: 10px;
  animation: slide-up 0.4s ease;
}
.oneBid:not(.ghost) {
  animation: slide-up 0.4s ease;
}
.dropZone {
  min-height: 70%;
}
@keyframes slide-up {
  0% {
    background: #c6c6c6;
    opacity: 0;
    transform: scale(0.5, 0.5);
  }
  100% {
    background: none;
    opacity: 1;
    transform: scale(1, 1);
  }
}
</style>
